import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api-base';
import { ISymbolPriceList } from './symbolPrice.interface';

export namespace SymbolPriceAction {
  const actionCreator = actionCreatorFactory('SymbolPrice');

  export const loadList = actionCreator.async<void, ISymbolPriceList, IApiErrorParams>('LOAD_LIST');

  export const exportFile = actionCreator.async<void, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
